<template>
  <div>
    <!-- NAVBAR -->
    <my-navbar :controller="controller"/>

    <!-- HEADER -->
    <div class="header bg-gradient-dark pb-8 pt-5 pt-md-8">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row">
            <!-- CONTENIDO HEADER -->
            <div class="col-lg-7 col-md-10">
              <h1 class="display-3 text-white">Eliminar Fantasmas</h1>
              <p
                  class="text-white mt-0 mb-5"
              >Eliminar avisos "fantasmas", vía código de la publicación.</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-3">
            <div class="card card-body">
              <my-spinner :loading="filters.loading"/>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="input-group input-group-alternative mb-4">
                      <input class="form-control form-control-alternative bg-white" type="text"
                             placeholder="Ingrese el código del aviso"
                             aria-label="Ingrese el código del aviso" aria-describedby="addon-code-advert"
                             v-model="filters.selected.cod_auto">
                      <div class="input-group-append">
                        <button class="input-group-text btn-update" @click="addCodeAdvert()"
                                :disabled="_codeAdvertError || _validateExistInListCode || listCodeAdverts.length === 5">
                          <i class="far fa-plus-square" :class="'text-white'"></i>
                        </button>
                      </div>
                    </div>
                    <span v-if="_codeAdvertError && filters.selected.cod_auto.toString().trim().length >= 5"
                          class="text-danger"
                          style="font-size: 12px">Código incorrecto. (Ex. CP-AD-XXXX o GI-AD-XXXX)</span>
                    <span v-if="_validateExistInListCode && filters.selected.cod_auto.toString().trim().length >= 5"
                          class="text-danger" style="font-size: 12px">Código ya agregado.</span>
                    <span v-if="listCodeAdverts.length === 5"
                          class="text-success" style="font-size: 12px">Lista de códigos completa.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card card-client shadow">
            <div class="card-body">
              <div class="row">

                <div class="col-md-7 col-sm-12 col-xs-12 card-client-details p-relative">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Código</th>
                      <th scope="col">Estado</th>
                      <th scope="col">Acción</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in listCodeAdverts">
                      <th scope="row" class="align-middle align-center">{{ index + 1 }}</th>
                      <td class="align-middle align-center">{{ item }}</td>
                      <td class="align-middle align-center">
                        <i v-if="loadingAdverts" class="mr-1 fa fa-spinner fa-spin text-primary"></i>
                        <i v-if="validateCodeInResponseRepublish(item) && responseRepublish"
                           class="mr-1 fas fa-check-circle text-success"></i>
                        <i v-if="!validateCodeInResponseRepublish(item) && responseRepublish"
                           class="mr-1 fas fa-times-circle text-danger"></i>
                      </td>
                      <td class="align-middle">
                        <button type="button" class="btn btn-outline-danger btn-rounded waves-effect"
                                @click="removeCodeAdvert(item)"><i
                            class="fas fa-minus-circle pr-2"
                            aria-hidden="true"></i>Quitar
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 text-right">
                  <button class="btn btn-success" style="margin-top: 20px;"
                          @click="republishAdverts()" :disabled="listCodeAdverts.length === 0"> Republicar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import _ from "underscore";
import clientesServices from "@/services/dealers.services";
import avisosServices from "@/services/avisos.services";
import ryvService from "@/services/ryvuss.services";

export default {
  name: "removeGhost",
  data() {
    return {
      loadingAdverts: false,
      advertsCount: "",
      codeAdvertsCP: false,
      codeAdvertsGI: false,
      codeAdvertsError: false,
      listCodeSuccess: [],
      listCodeError: [],
      listCodeAdverts: [],
      responseRepublish: false,
      actions: Auth.getActions(this.$route.name),
      controller: {
        title: "Operaciones",
        mainRouter: "/operaciones/avisos/eliminar-fantasmas"
      },
      filters: {
        clients: [],
        clientstmp: [],
        selected: {
          cod_auto: "",
          client: null
        },
        results: {},
        loading: false
      },
      toExport: {
        advertsCount: "",
      },
      messages: {
        danger: "",
        warning: ""
      }
    };
  },
  watch: {
    'filters.selected.cod_auto': {
      deep: true,
      handler(data) {
        this.filters.results = {};
      }
    }
  },
  computed: {
    _disabledBtn() {
      return !((this.filters.selected.cod_auto.toString().trim().length >= 7 && !this.codeAdvertsError));
    },
    isLoading() {
      return this.loadingAdverts;
    },
    _codeAdvertError() {
      return (!this._codeAdvertCP && !this._codeAdvertGI)
    },
    _codeAdvertCP() {
      return /((CP)-(AD)-[0-9]+)/.test(this.filters.selected.cod_auto.toUpperCase());
    },
    _codeAdvertGI() {
      return /((GI)-(AD)-[0-9]+)/.test(this.filters.selected.cod_auto.toUpperCase());
    },
    _validateExistInListCode() {
      return this.listCodeAdverts.find(x => x === this.filters.selected.cod_auto) !== undefined;
    }
  },
  methods: {
    addCodeAdvert() {
      if (!this._validateExistInListCode) {
        this.listCodeAdverts.push(this.filters.selected.cod_auto.toUpperCase());
        this.filters.selected.cod_auto = '';
      }
    },
    removeCodeAdvert(codeAdvert) {
      this.listCodeAdverts = this.listCodeAdverts.filter(x => x !== codeAdvert);
    },
    async republishAdverts() {
      this.filters.loading = true;
      this.loadingAdverts = true;
      this.responseRepublish = false;

      if (this.listCodeAdverts.length >= 1 && this.listCodeError.length >= 1) {
        this.listCodeSuccess.forEach(x => {
          this.removeCodeAdvert(this.listCodeAdverts.find(item => item === x));
        });

        this.listCodeSuccess = [];
        this.listCodeError = [];
      }

      await avisosServices.republishAdverts(this.listCodeAdverts).then(data => {
        this.listCodeSuccess = data.codesSuccess;
        this.listCodeError = data.codesError;

        this.filters.loading = false;
        this.loadingAdverts = false;
        this.responseRepublish = true;
      }).catch(error => {
        console.log('Component: RemoveGhost, FN: republishAdverts', error.message);
        sysMsgs.getMessage('No se pudo republicar los avisos.', 'error');
        this.filters.loading = false;
        this.loadingAdverts = false;
      });
    },
    validateCodeInResponseRepublish(advertCode) {
      return !!this.listCodeSuccess.find(x => x === advertCode);
    },
    getAdvertsCount(codCliente) {
      this.loadingAdverts = true;
      ryvService.getListingCount(codCliente).then(data => {
        this.advertsCount = data ? data.Count : "--";
        this.loadingAdverts = false;
      }).catch(error => {
        console.log('Component: RemoveGhost, FN: getAdvertsCount', error.message);
        sysMsgs.getMessage('No se pudo consultar la cantidad de avisos activos.', 'error');
        this.advertsCount = "--";
        this.loadingAdverts = false;
      });
    },
  }
};
</script>

<style scoped>
.btn-select {
  color: #ddd;
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 5px 10px;
}

.btn-select.active {
  color: #fff;
  background-color: #2dce89;
  border: 1px solid #2dce89;
}

.loading-overlay {
  left: 0;
  top: 0;
}

.opacity-01 {
  opacity: 0.1;
}
</style>
